import { Tag } from "@tryghost/content-api"
import { V3ParagraphGrey35 } from "../ReusableStyledComponents/V3ParagraphGrey35"
import { V3HeadlineH1 } from "../Typography"
import { VerticalSpacing } from "../VerticalSpacing"
import { BlogTagHeaderWrapper } from "./BlogTagHeader.styles"

interface BlogTagHeaderProps {
    tag: Tag
}

export const BlogTagHeader = ({ tag }: BlogTagHeaderProps) => <BlogTagHeaderWrapper>
    <VerticalSpacing bottom={36}>
        <V3HeadlineH1>{tag.name}</V3HeadlineH1>
    </VerticalSpacing>
    <VerticalSpacing bottom={36}>
        <V3ParagraphGrey35>{tag.description}</V3ParagraphGrey35>
    </VerticalSpacing>
</BlogTagHeaderWrapper>